// export const SERVER = "https://api.dsaos.com";
// export const API_URL = "https://api.dsaos.com/graphql";
// export const SOCKET_URL = "wss://api.dsaos.com/graphql";
// export const CLOUD_URL = "https://dsaos.sgp1.digitaloceanspaces.com/PRO/"

export const SERVER = "http://145.223.18.19:5000";
export const API_URL = "http://145.223.18.19:5000/graphql";
export const SOCKET_URL = "ws://145.223.18.19:5000/graphql";
export const CLOUD_URL = "https://drift-docs.s3.us-east-1.amazonaws.com/DEV/";

// export const SERVER = "http://localhost:5000";
// export const API_URL = "http://localhost:5000/graphql";
// export const SOCKET_URL = "ws://localhost:5000/graphql";
// export const CLOUD_URL = "https://dsaos.sgp1.digitaloceanspaces.com/DEV/";

// export const SERVER = "https://daa5-2405-201-200c-9186-2c60-4be3-6865-d908.in.ngrok.io";
// export const API_URL = "https://daa5-2405-201-200c-9186-2c60-4be3-6865-d908.in.ngrok.io/graphql";
// export const SOCKET_URL = "ws://daa5-2405-201-200c-9186-2c60-4be3-6865-d908.in.ngrok.io/graphql";
// export const CLOUD_URL = "https://dsaos.sgp1.digitaloceanspaces.com/DEV/";


export const WEB_URL = "https://dsaos.com";
